<ng-template #defaultTemplate>
    <span>{{file ? file.name : 'or drag and drop file here' }}</span>
</ng-template>

<ng-container
              *ngTemplateOutlet="fileUploadTemplate ? fileUploadTemplate : defaultTemplate; context: { $implicit: file }">
</ng-container>
<input type="file"
       [attr.accept]="accept">